<template>
	<v-alert
		:value="true"
		:type="type"
	>
		{{ message }}
	</v-alert>
</template>

<script>
	export default {
		name: "message-box",

		components: {},
		props: {
			// Specify a success, info, warning or error alert. Uses the contextual color and a pre-defined icon.
			type: {
				default: "error",
			},
			message: {
				require: true,
			},
		},
		data () {
			return {};
		},
		computed: {

		},
		created () {
		},
		mounted () {
		},
		updated () {
		},
		destroyed () {
		},
		methods: {
			onCloseClick () {
				this.$emit("close");
			},
		},
	};
</script>

<style>

</style>
